
import { Card, List  } from "@mui/material";

import { AlarmScheduleUsageListItem } from "./AlarmScheduleUsageListItem";
import { AlarmScheduleListActionEnum } from "./AlarmScheduleListUtils";
import { IAlarmScheduleLinkedAlarmSchemeModel } from "../../../services/alarm-schedule-data-service/Models";

export type AlarmScheduleUsageCardProps = {
    items: IAlarmScheduleLinkedAlarmSchemeModel[],
    onAction?: (action: AlarmScheduleListActionEnum, payload: IAlarmScheduleLinkedAlarmSchemeModel) => void,
};

export function AlarmScheduleUsageCard({
    items,
    onAction
}: AlarmScheduleUsageCardProps) {


    return (

        <Card variant="outlined"
            sx={{
            display: 'flex',
            flex: '1 1 auto',
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 4,
            marginRight: 1,
            marginBottom: 1,
            padding: 1
        }}>

            <List sx={{
                paddingTop: 0,
                overflowX: "hidden",
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto'        
            }}>

                {items.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))?.map((o, index) =>

                    <AlarmScheduleUsageListItem 
                        key={index} 
                        item={o} 
                        onAction={(action, payload) => { onAction && onAction(action, payload)}} />

                )}                                      
            </List>

        </Card>    
    );
}





